import dynamic from 'next/dynamic'
import React from 'react'

const AssetsProvider = dynamic(
  () =>
    import(
      /* webpackChunkName: 'module-providers-layout' */
      'providers/Assets'
    )
)
const DrawersProvider = dynamic(
  () =>
    import(
      /* webpackChunkName: 'module-providers-layout' */
      'providers/DrawersProvider'
    )
)
const ThemeProvider = dynamic(
  () =>
    import(
      /* webpackChunkName: 'module-providers-layout' */
      'providers/Theme'
    )
)
const BaseStructure = dynamic(
  () =>
    import(
      /* webpackChunkName: 'module-components-baseStructure' */
      'components/Base/Base.index'
    )
)

const LayoutProvider: React.FC<any> = ({ children }) => {
  return (
    <ThemeProvider>
      <AssetsProvider>
        <DrawersProvider>
          <BaseStructure>
            {children}
          </BaseStructure>
        </DrawersProvider>
      </AssetsProvider>
    </ThemeProvider>
  )
}

export default LayoutProvider
